import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { BaseApiService } from '../../../components/core/services/base-api.service';
import { CALCULATE_ALL_FUNDS_API } from '../../../data-access/constants/api';

@Injectable({
  providedIn: 'root',
})
export class CalculatorService {
  constructor(private baseApiService: BaseApiService) {
  }

  getFunds({
             fromDate,
             toDate,
             amount,
           }: {
    fromDate: string;
    toDate: string;
    amount: number;
  }) {
    const params = new HttpParams()
      .set('startDate', fromDate)
      .set('endDate', toDate)
      .set('InvestValue', amount);
    return (
      this.baseApiService
        // headers
        .get(CALCULATE_ALL_FUNDS_API, params)
        .pipe(map((value) => value.result))
    );
  }
}
